import { Lexer } from "./Lexer";

export type CWORD = "CWORD";
export type JSWORD = "JSWORD";
export type PHPWORD = "PHPWORD";
export type CFUNCTION = "CFUNCTION";
export type CLASSNAME = "CLASSNAME";

export type CSS_ID_SELECTOR = "CSS_ID_SELECTOR";
export type CSS_CLASS_SELECTOR = "CSS_CLASS_SELECTOR";
export type CSS_WORD = "CSS_WORD";

export type HTML_CUSTOM_ELEMENT = "HTML_CUSTOM_ELEMENT";

export type DOUBLE_QUOTED_STRING = "DOUBLE_QUOTED_STRING";
export type SINGLE_QUOTED_STRING = "SINGLE_QUOTED_STRING";

export type NUMBER = "NUMBER";
export type BOOL = "BOOL";

export type WHITESPACE = "WHITESPACE";

export type BREAK = "BREAK";
export type NULL = "NULL";

export type LOGIC = "LOGIC";
export type OPERATOR = "OPERATOR";
export type BRACKET = "BRACKET";

export type BLOCKSTART = "BLOCKSTART";
export type BLOCKEND = "BLOCKEND";

export type ANY_SYMBOL = "ANY_SYMBOL";

export type HASH_TAG = "HASH_TAG";
export type URL = "URL";

export type CLASS = "CLASS";

export type ACCESS_MODIFIER = "ACCESS_MODIFIER";

export type SINGLE_LINE_COMMENT = "SINGLE_LINE_COMMENT";
export type MULTI_LINE_COMMENT = "MULTI_LINE_COMMENT";

export type C_INSTRUCTION = "C_INSTRUCTION";

export type LexerType = 
  CWORD | 
  JSWORD |
  PHPWORD |

  CFUNCTION |
  CLASSNAME |

  CSS_ID_SELECTOR |
  CSS_CLASS_SELECTOR |
  CSS_WORD |

  HTML_CUSTOM_ELEMENT |
  
  DOUBLE_QUOTED_STRING | 
  SINGLE_QUOTED_STRING | 
  NUMBER |
  BOOL |
  WHITESPACE | 
  BREAK | 
  NULL |

  LOGIC |
  OPERATOR | 
  BRACKET |

  BLOCKSTART | 
  BLOCKEND |
  
  ANY_SYMBOL | 
  
  CLASS |

  ACCESS_MODIFIER | 
  SINGLE_LINE_COMMENT |
  MULTI_LINE_COMMENT |

  C_INSTRUCTION
;
 
export class LexerTypes
{
  static readonly CWORD:CWORD = "CWORD"; 
  static readonly JSWORD:JSWORD = "JSWORD";
  static readonly PHPWORD:PHPWORD = "PHPWORD";

  static readonly CFUNCTION:CFUNCTION = "CFUNCTION";
  static readonly CLASSNAME:CLASSNAME = "CLASSNAME";

  static readonly CSS_ID_SELECTOR:CSS_ID_SELECTOR = "CSS_ID_SELECTOR";
  static readonly CSS_CLASS_SELECTOR:CSS_CLASS_SELECTOR = "CSS_CLASS_SELECTOR";
  static readonly CSS_WORD:CSS_WORD = "CSS_WORD";

  static readonly HTML_CUSTOM_ELEMENT:HTML_CUSTOM_ELEMENT = "HTML_CUSTOM_ELEMENT";

  static readonly DOUBLE_QUOTED_STRING:DOUBLE_QUOTED_STRING = "DOUBLE_QUOTED_STRING";
  static readonly SINGLE_QUOTED_STRING:SINGLE_QUOTED_STRING = "SINGLE_QUOTED_STRING";
  static readonly NUMBER:NUMBER = "NUMBER";
  static readonly BOOL:BOOL = "BOOL";
  static readonly WHITESPACE:WHITESPACE = "WHITESPACE";
  static readonly BREAK:BREAK = "BREAK";
  static readonly NULL:NULL = "NULL";

  static readonly LOGIC:LOGIC = "LOGIC";
  static readonly OPERATOR:OPERATOR = "OPERATOR";
  static readonly BRACKET:BRACKET = "BRACKET";

  static readonly BLOCKSTART:BLOCKSTART = "BLOCKSTART";
  static readonly BLOCKEND:BLOCKEND = "BLOCKEND";

  static readonly CLASS:CLASS = "CLASS";
  static readonly C_INSTRUCTION = "C_INSTRUCTION";

  static readonly ANY_SYMBOL:ANY_SYMBOL = "ANY_SYMBOL";

  static readonly HASH_TAG:HASH_TAG = "HASH_TAG";

  static readonly URL:URL = "URL";

  static readonly ACCESS_MODIFIER = "ACCESS_MODIFIER";

  static readonly SINGLE_LINE_COMMENT = "SINGLE_LINE_COMMENT";
  static readonly MULTI_LINE_COMMENT = "MULTI_LINE_COMMENT";

  static get IGNORE_TYPES():LexerType[]
  {
    let ignoreTypes:LexerType[] = [
      LexerTypes.SINGLE_LINE_COMMENT,
      LexerTypes.DOUBLE_QUOTED_STRING,
      LexerTypes.WHITESPACE,
      LexerTypes.BREAK
    ];

    return ignoreTypes;
  }

}